export default {
  metaTitle: 'Quick Product Editing',
  listingId: 'Listing ID',
  title: 'Product name',
  skuCount: 'SKUs',
  editListing: 'Partial Editing',
  fullEditFun: 'Fully Editing',
  showCountry: 'Country Site',
  baseStation: 'Basic',
  expand: 'Extension',
  finalFreight: 'Last Mile Freight ',
  priceUse: 'Batch Price Modify',
  nation: 'Applied country',
  listPriceSection: 'Current Market Reference Price Range',
  salePriceSection: 'Current Selling Price Range',
  newPrice: 'Please enter the new prices',
  notFill: 'Leave blank for prices not being modified',
  cancel: 'Cancel',
  determine: 'Confirm',
  listingTitle: 'Product name',
  chooseCategory: 'Selected category',
  brand: 'Brand',
  shortDescr: 'Short description',
  warehouse: 'Warehouse',
  onlinePay: 'Online Payment',
  COD: 'Pay on Delivery',
  category: 'Category',
  paymentMethod: 'Payment Method',
  excludePaymentMethod: 'Payment option declined',
  online: 'Online Payment',
  manufactureId: 'Vendor Product ID',
  listPrice: 'Market Reference Price',
  salePrice: 'Selling Price',
  quantity: 'Quantity',
  availableStock: 'Available Inventory',
  photos: 'Thumbnail',
  titleRules: 'Product name cannot be empty.',
  warehouseRules: 'Please select warehouse.',
  integerRules: 'Please enter an integer.',
  SKU_ID: 'SKU ID',
  manufacture_ID: 'Vendor Product ID',
  mainSpec: 'Variation',
  operation: 'Operate',
  setOnline: 'Active',
  setOffline: 'Inactive',
  priceNot_0: 'Price cannot be 0！',
  priceCannotHigher: 'Selling price cannot be higher than market reference price.',
  JPG_GIF_PNG: 'Please upload JPG GIF or PNG images.',
  file_2M: 'The file is too large, please do not exceed 2 MB.',
  image_5: 'Upload up to 5 images.',
  saveEdit: 'Please save or close the SKU editing panel.',
  successEdit: 'The price has been modified successfully.',
  inputError: 'Input error',
  newPriceUse: 'Please enter the new price',
  priceUnder: 'Market reference price and selling price are 30% less than the original minimum price. Are you sure to modify?',
  priceExceed: 'Market reference price and selling price are 50% higher than the original maximum price, Are you sure to modify?',
  listPriceUnder: 'The market reference price is 30% less than the original minimum price. Are you sure to modify?',
  listPriceExceed: 'The market reference price is 50% higher than the original maximum price. Are you sure to modify?',
  salePriceUnder: 'The selling price is 30% lower than the original minimum price. Are you sure to modify?',
  salePriceExceed: 'The selling price is 50% higher than the original maximum price. Are you sure to modify?',
  unable: 'The selling price cannot be higher than the market reference price',
  maxListPrice: 'The market reference price can not be lower than the maximum value of original selling price',
  minListPrice: 'The selling price can not be higher than the minimum value of original market reference price.',

  prePaymentSite: 'Prepayment Setting',
  prePaymentSiteProduct: 'Prepayment Setting',
  preRatio: 'Prepayment Ratio',
  preRatioItem1: 'Uniformly set by platform',
  preRatioItem2: 'Do not support prepayment',
  preRatioItem3: 'Set individually for this product',
  preRatioLimit: 'Integer between 1 and 80',
  merge: 'Consolidated Ordering',
  allow: 'Allowed',
  notAllow: 'Not allowed',
  preTips1: 'When allowed, the product can be added to the shopping cart and submitted as a single order along with other mergeable products.',
  preTips2: 'When not allowed, the product can not be added to shopping cart, buyer can only purchase separately.',
  save: 'Save',
  ratioCheck: 'Prepayment ratio have to be an integer between 1 and 80.',
  product: 'This product has been QC locked and cannot be edited.',
  violations: 'This product has been processed for violations.',
  productViolations: 'This product has been QC locked and cannot be edited.',
  notFbkProduct: 'Not FBK Product',
  physicalWarehouse: 'FBK Stock:{0}, Avail:{1},View Details',
  nonFbkInventory: 'Non-FBK Inventory: {0} (Avail.',
  fbkInventory: 'FBK Inventory:  {0} (Avail. {1})',
  nonFbk: 'Non-FBK',
  pleaseAvailInventory: 'Please enter inventory'
}
